<template>
  <div class="call-box">
    <div
      style="padding: 0.8rem 0 2.7rem 0; text-align: center; font-size: 0.44rem"
    ></div>
    <div class="img-box">
      <img class="small" :src="info.avatar?info.avatar:require('../img/touxiang.png')" />
      <p
        style="font-size: 0.36rem; font-weight: 500; color: rgba(64, 64, 64, 1)"
      >
        {{info.name}}
      </p>
      <div style="position: relative">
        <img class="code" src="../img/code-kuang.png" />
        <img
          class="code"
          :src="info.codeUrl?info.codeUrl:require('../img/new-code.png')"
          style="
            position: absolute;
            left: 0;
            right: 0;
            top: 19%;
            width: 3.6rem;
            margin: auto;
          "
        />
      </div>
      <p class="txt">请截图保存至手机相册，扫码添加客服微信</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "call",
  data() {
    return {
      view: false,
      info: {},
      channelType:""
    };
  },
  created() {
    this.$api.aide().then((res) => {
      if (res.errno == "0") {
        this.info = res.data;
        this.view = true;
      }
    });
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
};
</script>

<style lang="scss" scoped>
.call-box {
  background-image: url("../img/call-bg.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
  background-color: #ffffff;

  .img-box {
    width: 684px;
    /*height:800px;*/
    padding-bottom: 80px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 20px rgba(221, 43, 30, 0.08);
    border-radius: 16px;

    margin: 0 auto;
    display: flex;
    flex-flow: column;
    align-items: center;

    .small {
      width: 188px;
      height: 188px;
      margin-top: -94px;
      margin-bottom: 24px;
      border-radius: 50%;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    }

    .code {
      width: 412px;
      margin: 80px 0 50px 0;
    }
    .txt {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>
